import BreadCrumb from "../../src/components/Shared/BreadCrumb";
import { Col, Container, Row } from "react-bootstrap";
import Link from "next/link";
import Image from "next/image";

 import Faqs from "../../src/components/Shared/Faqs";
import Contact from "../../src/components/Home/Contact";
import BlogItem from "../../src/components/Home/BlogItem";
import defaultImage from "../../src/assets/images/default.png";
import server from "../../src/api/server";
import { FormattedMessage, useIntl } from "react-intl";
import { NextSeo } from "next-seo";
const SingleBlog = ({
  blogsData,
  blogCategoryResponse,
  latestBlogsResponse,
  socialsData,
  error,

  breadBackground,
  contactUsBack,
}) => {
  error && console.log(error);
  const { locale } = useIntl();
  const blog = blogsData;
  const renderBlogCategories = blogCategoryResponse?.map((category, index) => {
    return (
      <li key={category?.id}>
        <Link href={`/blog/categories/${category?.id}`}>
          <a aria-label="categories">
            <span>.0{index + 1}</span>
            {category?.title?.[locale]}
          </a>
        </Link>
      </li>
    );
  });

  const renderSimilarBlogs = latestBlogsResponse
    ?.filter((similar) => similar.id !== blog?.id)
    .map((similar, index) => (
      <li key={similar.id}>
        <BlogItem blog={{ ...similar, count: index + 1 }} />
      </li>
    ));

  return (
    <>
      <NextSeo
        title={blog?.contents?.meta?.title[locale] || blog?.title[locale]}
        description={
          blog?.contents?.meta?.description[locale] || blog?.description[locale]
        }
        additionalMetaTags={[
          {
            name: "keywords",
            content: "",
          },
          {
            name: "description",
            content: "",
          },
        ]}
      />
      <div className="single-service single-blog">
        <BreadCrumb
          title={blog?.title?.[locale]}
          pageTitle={blog?.title?.[locale]}
          breadBackground={breadBackground}
        />
        <div className="single-service-body">
          <Container>
            <Row>
              <Col className="all-blog-content" xl={9} lg={9} md={12} xs={12}>
                <div className="service-content mb-5">
                  <div className="service-slider">
                    <div className="img-holder mb-4">
                      <Image
                        src={
                          (blog?.image &&
                            `${process.env.NEXT_PUBLIC_MAIN_URL}${blog?.image}`) ||
                          defaultImage.src
                        }
                        width={970}
                        height={400}
                        alt=""
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div
                    className="blog-content"
                    style={{ textAlign: "justify" }}
                    dangerouslySetInnerHTML={{
                      __html:blog?.description?.[locale]
                    }}
                  >
                   </div>
                </div>
                <Faqs faqs={blog?.contents?.faqs} />
              </Col>
              <Col xl={3} lg={3} md={12} xs={12}>
                <div className="sidebar">
                  <div className="widget">
                    <h4>
                      <FormattedMessage id="blogsCategories" />
                    </h4>
                    <div className="service-list">
                      <ul>{renderBlogCategories}</ul>
                    </div>
                  </div>
                  <div className="widget">
                    <h4>
                      <FormattedMessage id="similarBlogs" />
                    </h4>
                    <div className="similar-blogs">
                      <ul>{renderSimilarBlogs}</ul>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <Contact
          {...{
            socialsData,
            contactUsBack,
          }}
        />
      </div>
    </>
  );
};
export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}
export const getStaticProps = async (ctx) => {
  try {
    const { id } = ctx.params;
    const socialsResponse = await server.get("/settings/socials");
    const blogResponse = await server.get(`/blogs/${id}`);
    const blogCategoryResponse = await server.get(`/categories`);
    const latestBlogsResponse = await server.get(`/blogs/latestBlogs`);
    const metaDataResponse = await server.get("/pages/metaData");
    let breadBack, contactUsBack;
    try {
      const backgroundResponse = await server.get("/pages/backgrounds");
      breadBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "breadcrumbs"
      )?.image;
      contactUsBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "contactUs"
      )?.image;
    } catch (err) {
      console.log(err);
    }

    return {
      revalidate: 1,
      props: {
        socialsData: socialsResponse?.data?.data?.socials,
        blogsData: blogResponse?.data?.data?.blogObj,
        blogCategoryResponse: blogCategoryResponse?.data?.data?.categories,
        latestBlogsResponse: latestBlogsResponse?.data?.data?.blogs,
        metaDataSections: metaDataResponse?.data?.data?.page?.sections,
        breadBackground: breadBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${breadBack}`
          : null,
        contactUsBack: contactUsBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${contactUsBack}`
          : null,
      },
    };
  } catch (error) {
    return {
      revalidate: 1,
      props: {
        error: JSON.stringify(error),
      },
    };
  }
};
export default SingleBlog;
